import React, { useEffect, useState } from 'react';
import Header from "./Header";
import {
    Card,
    CardHeader,
    Container,
    Pagination,
    Row,
    Table,
} from "reactstrap";
import { getInstitutions, getImage, postImage, putSubscription } from "../../../../network/ApiAxios";
import secureLocalStorage from "react-secure-storage";

const Test = () => {

    const [tests, setTest] = useState([]);
    const [image, setImage] = useState()
    const [fileKey, setFileKey] = useState()
    const [selectedFile, setSelectedFile] = useState(null);
    const user = JSON.parse(secureLocalStorage.getItem("user"));

    /*
    useEffect(() => {

        console.log(user)
        console.log(process.env)

        const runAsync = async () => {

            let params = {
                filter: {
                    account: user.account
                },
                pagination: {
                    skip: 10,
                    limit: 2
                }
            }

            const response = await getInstitutions(params);
            const { data } = response;
            console.log(data);

            if (data.success) {
                console.log(data);
            }
        }
        runAsync();
    }, []);
    */

    
    useEffect(() => {
        console.log(user)
        loadImage()
    }, [fileKey]); 
    

    const handleFileChange = (event) => {
        setSelectedFile(event.target.files[0]);
    };
    
    const loadImage = async () => {

        if(fileKey){
            const response = await getImage(fileKey);
            const {data} = response;            
            setImage(data)
        }
    }

    const handleUpload = async () => {
        if (!selectedFile) {
            alert('Please select a file first!');
            return;
        }

        try {
            const reader = new FileReader();
            reader.onloadend = async () => {
                const base64Image = reader.result.split(',')[1]; // Get Base64 part                 
                let extension = selectedFile.type.split('/')[1] //Get file extension
                let params = { 
                    account: user.account,
                    imageData: base64Image, 
                    fileName: selectedFile.name,
                    fileType: extension, 
                    objectId: user._id 
                }

                const response = await postImage(params);
                const { data } = response;                
                console.log(data);

                if (data.success) {
                    setFileKey(data.imageID.toString())
                    loadImage()
                }
            };
            reader.readAsDataURL(selectedFile);
            
        } catch (error) {
            console.error('Error uploading image:', error);
        }
    };

    return (
        <>
            <Header />
            <Container>
                <Row>
                    <div className="col">
                        <Card className="shadow">
                            <CardHeader className="border-0">
                                <h3 className="mb-0">Test</h3>
                            </CardHeader>

                            <input type="file" onChange={handleFileChange} />
                            <button onClick={handleUpload}>Upload Image</button>

                            <img src={image}></img>

                            <Table className="align-items-center table-flush" responsive>
                                <thead className="thead-light">
                                    <tr>
                                        <th scope="col">Name</th>
                                        <th scope="col">Email</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {tests.map(test => (
                                        <tr key={test.email}>
                                            <th scope="row">
                                                {test.name}
                                            </th>
                                            <td>{test.email}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </Card>
                    </div>
                </Row>
            </Container>
        </>
    );
}

export default Test;
